import {
	allBrands,
	arrType,
	createdByColumns,
	datatypes,
	inputTypes,
	publishColumns,
	selectOptionsKeyName,
	statusOptions,
} from "data/globalData";
import { admin, custom } from "data/authData";
import { getRoleScopes } from "components/Users/utils/roleHelpers";
import { NAOption } from "../../Designer/CreateStyle/data";
import moment from "moment";

export const TRIMS_VIEW_LEVELS = {
	MASTER: "MASTER",
	SUPPLIER: "SUPPLIER",
};

export const trimsViewLevelOptions = [
	{ key: TRIMS_VIEW_LEVELS.MASTER, name: "Master" },
	{ key: TRIMS_VIEW_LEVELS.SUPPLIER, name: "Supplier" },
];

export const isTrimSupplierBlocked = (user) => user?.role?.[custom.BLOCK_TRIM_SUPPLIER_PRICING.key] === true;

export const TRIM_PUBLISH_STATUS = {
	CREATED: statusOptions.CREATED.key,
	PENDING: "PENDING",
	PUBLISHED: statusOptions.PUBLISHED.key,
	REJECTED: statusOptions.REJECTED.key,
};

export const trimPublishStatusDisplay = {
	[TRIM_PUBLISH_STATUS.CREATED]: { label: "CREATED", color: "#e65100", bgcolor: "#fff3e0" },
	[TRIM_PUBLISH_STATUS.PENDING]: { label: "UNPUBLISHED", color: "#e65100", bgcolor: "#ffe0b2" },
	[TRIM_PUBLISH_STATUS.PUBLISHED]: { label: "PUBLISHED", color: "#2e7d32", bgcolor: "#e8f5e9" },
	[TRIM_PUBLISH_STATUS.REJECTED]: { label: "REJECTED", color: "#b71c1c", bgcolor: "#ffebee" },
};

export const getTrimPublishStatusDisplay = (status) =>
	trimPublishStatusDisplay[status] || trimPublishStatusDisplay[TRIM_PUBLISH_STATUS.CREATED];

export const isTrimPublished = (row = {}) => row?.status === TRIM_PUBLISH_STATUS.PUBLISHED;

export const getAllowedTrimsBrandOptions = (user, action = "read") => {
	const allBrandOptions = Object.values(allBrands);
	if (user?.role?.[admin]) return allBrandOptions;

	const scopedBrands = getRoleScopes(user?.role)?.brand?.[action];
	if (!scopedBrands?.length) return allBrandOptions;

	return scopedBrands.map((key) => allBrands[key] || { name: key, key });
};

export const trimFileTypes = {
	TRIM_IMAGES: "TRIM_IMAGES",
	TRIM_DEV_FILES: "TRIM_DEV_FILES",
};

export const isValidTrimImageUrl = (url) => {
	if (!url || typeof url !== "string") return false;
	const trimmed = url.trim();
	if (!trimmed) return false;
	if (trimmed === trimActiveStatusDropdowns?.INACTIVE?.key || trimmed === trimActiveStatusDropdowns?.ACTIVE?.key) return false;
	return true;
};

export const trimCategoryDropdowns = [
	{ key: "LABEL", name: "LABEL" },
	{ key: "BUTTON", name: "BUTTON" },
	{ key: "BADGE", name: "BADGE" },
	{ key: "ELASTIC", name: "ELASTIC" },
	{ key: "HANGTAG", name: "HANGTAG" },
	{
		key: "METAL",
		name: "METAL",
	},
	{ key: "TAPE", name: "TAPE" },
	{ key: "STICKER", name: "STICKER" },
	{ key: "STRING", name: "STRING" },
	{ key: "CORD", name: "CORD" },
	{ key: "ZIPPER", name: "ZIPPER" },
	{ key: "THREAD", name: "THREAD" },
	{ key: "INTERLINING", name: "INTERLINING" },
	{ key: "OTHER", name: "OTHER" },
	{ key: "LACE", name: "LACE" },
];

export const trimCategoryColumn = {
	name: "Item Category",
	key: "item_category",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	constraints: { NOTNULL: true, DISPLAY: true },
	[selectOptionsKeyName]: {
		type: arrType,
		list: trimCategoryDropdowns,
	},
};

export const trimCategoryDropdownsObj = trimCategoryDropdowns.reduce((acc, option) => {
	acc[option.key] = option;
	return acc;
}, {});

export const trimSubCategoryDropdowns = [
	{ key: "MAIN LABEL", name: "MAIN LABEL", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LABEL?.key || "" },
	{ key: "SHOE LABEL", name: "SHOE LABEL", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LABEL?.key || "" },
	{ key: "SIZE LABEL", name: "SIZE LABEL", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LABEL?.key || "" },
	{ key: "EXTRA LABEL", name: "EXTRA LABEL", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LABEL?.key || "" },
	{ key: "LOOP LABEL", name: "LOOP LABEL", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LABEL?.key || "" },
	{ key: "GUSSET LABEL", name: "GUSSET LABEL", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LABEL?.key || "" },
	{ key: "SLEEVE LABEL", name: "SLEEVE LABEL", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LABEL?.key || "" },
	{ key: "MAIN WITH SIZE", name: "MAIN WITH SIZE", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LABEL?.key || "" },
	{ key: "WOVEN ELASTIC", name: "WOVEN ELASTIC", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.ELASTIC?.key || "" },
	{ key: "KNITTED ELASTIC", name: "KNITTED ELASTIC", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.ELASTIC?.key || "" },
	{ key: "JACQUARD ELASTIC", name: "JACQUARD ELASTIC", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.ELASTIC?.key || "" },
	{
		key: "KNITTED SPANDEX ELASTIC",
		name: "KNITTED SPANDEX ELASTIC",
		[trimCategoryColumn.key]: trimCategoryDropdownsObj?.ELASTIC?.key || "",
	},
	{ key: "GEL PRINT ELASTIC", name: "GEL PRINT ELASTIC", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.ELASTIC?.key || "" },
	{ key: "HAND SEW BUTTON", name: "HAND SEW BUTTON", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.METAL?.key || "" },
	{ key: "WOVEN TAPE", name: "WOVEN TAPE", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.TAPE?.key || "" },
	{ key: "KNITTED TAPE", name: "KNITTED TAPE", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.TAPE?.key || "" },
	{ key: "JACQUARD TAPE", name: "JACQUARD TAPE", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.TAPE?.key || "" },
	{ key: "WOVEN KNITTED TAPE", name: "WOVEN KNITTED TAPE", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.TAPE?.key || "" },
	{ key: "STICKER", name: "STICKER", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.STICKER?.key || "" },
	{ key: "STRING", name: "STRING", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.STRING?.key || "" },
	{ key: "BUTTON", name: "BUTTON", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.BUTTON?.key || "" },
	{ key: "HANGTAG", name: "HANGTAG", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.HANGTAG?.key || "" },
	{ key: "BADGE", name: "BADGE", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.BADGE?.key || "" },
	{ key: "INTERLINING", name: "INTERLINING", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.INTERLINING?.key || "" },
	{ key: "ZIPPER", name: "ZIPPER", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.ZIPPER?.key || "" },
	{ key: "TOP STITCH", name: "TOP STITCH", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.THREAD?.key || "" },
	{ key: "OVERLOCK", name: "OVERLOCK", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.THREAD?.key || "" },
	{ key: "BARTACK", name: "BARTACK", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.THREAD?.key || "" },
	{ key: "GENERAL SEWING", name: "GENERAL SEWING", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.THREAD?.key || "" },
	{ key: "CORD", name: "CORD", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.CORD?.key || "" },
	{ key: "SHOE LACE", name: "SHOE LACE", [trimCategoryColumn.key]: trimCategoryDropdownsObj?.LACE?.key || "" },
];

export const trimFinalFinishedReqDropdowns = [
	{ key: "END FOULD", name: "END FOULD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{ key: "CENTER + END FOULD", name: "CENTER + END FOULD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{ key: "DIE CUT WITH FUSE", name: "DIE CUT WITH FUSE", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{
		key: "DIE CUT WITH FUSE + MERROWING",
		name: "DIE CUT WITH FUSE + MERROWING",
		[trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key,
	},
	{
		key: "DIE CUT WITH SILICON GUM",
		name: "DIE CUT WITH SILICON GUM",
		[trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key,
	},
	{ key: "CENTER FOULD", name: "CENTER FOULD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{ key: "CENTER FOULD", name: "CENTER FOULD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
];

export const zipperPullerCodeDropdowns = [
	{
		key: "RAR01",
		name: "RAR01",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
			{ name: "#8", key: "#8" },
		],
	},
	{
		key: "RAR02",
		name: "RAR02",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR03",
		name: "RAR03",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{ key: "RAR04", name: "RAR04", dropdowns: [{ name: "#3", key: "#3" }] },
	{ key: "RAR05", name: "RAR05", dropdowns: [{ name: "#3", key: "#3" }] },
	{ key: "RAR06", name: "RAR06", dropdowns: [{ name: "#3", key: "#3" }] },
	{
		key: "RAR07",
		name: "RAR07",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
			{ name: "#8", key: "#8" },
		],
	},
	{ key: "RAR08", name: "RAR08", dropdowns: [{ name: "#3", key: "#3" }] },
	{
		key: "RAR09",
		name: "RAR09",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR10",
		name: "RAR10",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR11",
		name: "RAR11",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR12",
		name: "RAR12",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{ key: "RAR13", name: "RAR13", dropdowns: [{ name: "#3", key: "#3" }] },
	{ key: "RAR14", name: "RAR14", dropdowns: [{ name: "#3", key: "#3" }] },
	{
		key: "RAR15",
		name: "RAR15",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR18",
		name: "RAR18",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR19",
		name: "RAR19",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR21",
		name: "RAR21",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{ key: "RAR22", name: "RAR22", dropdowns: [{ name: "#3", key: "#3" }] },
	{ key: "RAR23", name: "RAR23", dropdowns: [{ name: "#3", key: "#3" }] },
	{ key: "RAR24", name: "RAR24", dropdowns: [{ name: "#3", key: "#3" }] },
	{ key: "RAR25", name: "RAR25", dropdowns: [{ name: "#3", key: "#3" }] },
	{
		key: "RAR26",
		name: "RAR26",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{ key: "RAR27", name: "RAR27", dropdowns: [{ name: "#3", key: "#3" }] },
	{
		key: "RAR28",
		name: "RAR28",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR29",
		name: "RAR29",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR30 (MTL-RR-331)",
		name: "RAR30 (MTL-RR-331)",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "RAR31",
		name: "RAR31",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
	{
		key: "MTL-RR-320",
		name: "MTL-RR-320",
		dropdowns: [
			{ name: "#3", key: "#3" },
			{ name: "#5", key: "#5" },
		],
	},
];

export const trimDeliveryStatusDropdownObj = {
	PENDING: { key: "PENDING", name: "PENDING" },
	RECEIVED: { key: "RECEIVED", name: "RECEIVED" },
};

export const trimSupplierDropdowns = [
	{ key: "J K LABEL", name: "J K LABEL", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{ key: "PRIME LABEL", name: "PRIME LABEL", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{ key: "ATAM LABEL", name: "ATAM LABEL", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{
		key: "MANOHAR FILAMENTS (P) LTD",
		name: "MANOHAR FILAMENTS (P) LTD",
		[trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key,
	},
	{ key: "AREX INDUSTRIES LTD.", name: "AREX INDUSTRIES LTD.", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{ key: "BANGALORE SALES", name: "BANGALORE SALES", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BUTTON?.key },
	{ key: "MULTI SALES", name: "MULTI SALES", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BUTTON?.key },
	{ key: "BHANU BUTTONS", name: "BHANU BUTTONS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BUTTON?.key },
	{ key: "JINDAL BUTTONS", name: "JINDAL BUTTONS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BUTTON?.key },
	{ key: "AERO BUTTONS", name: "AERO BUTTONS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BUTTON?.key },
	{ key: "ACE TRIMS", name: "ACE TRIMS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BADGE?.key },
	{ key: " PRIYA INTL", name: "PRIYA INTL", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BADGE?.key },
	{ key: "PHOENIX", name: "PHOENIX", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BADGE?.key },
	{ key: "NAVEEN ENTR", name: "NAVEEN ENTR", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BADGE?.key },
	{ key: "RELIABLE", name: "RELIABLE", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BADGE?.key },
	{ key: "MOVEYAA & ARW", name: "MOVEYAA & ARW ", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BADGE?.key },
	{ key: "BALAJI SUPPER SPENDEX", name: "BALAJI SUPPER SPENDEX", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.ELASTIC?.key },
	{
		key: "MANOHAR FILAMENTS (P) LTD",
		name: "MANOHAR FILAMENTS (P) LTD",
		[trimCategoryColumn?.key]: trimCategoryDropdownsObj?.ELASTIC?.key,
	},
	{
		key: "DONGGUAN CINDA GARMENT",
		name: "DONGGUAN CINDA GARMENT",
		[trimCategoryColumn?.key]: trimCategoryDropdownsObj?.ELASTIC?.key,
	},
	{ key: "PREMCO GLOBAL", name: "PREMCO GLOBAL", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.ELASTIC?.key },
	{ key: "MRB LACE", name: "MRB LACE", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "RELIABLE", name: "RELIABLE", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "MOVEYAA & ARW", name: "MOVEYAA & ARW ", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "MOVEYAA & ARW", name: "MOVEYAA & ARW ", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "PRAKASH CREATIONS", name: "PRAKASH CREATIONS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "RKS", name: "RKS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.HANGTAG?.key },
	{ key: "JINDAL BUTTONS", name: "JINDAL BUTTONS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.METAL?.key },
	{ key: "AERO BUTTONS", name: "AERO BUTTONS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.METAL?.key },
	{ key: "ACE TRIMS", name: "ACE TRIMS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.METAL?.key },
	{ key: " PRIYA INTL", name: "PRIYA INTL", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.METAL?.key },
	{ key: "PHOENIX", name: "PHOENIX", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.METAL?.key },
	{ key: "NAVEEN ENTR", name: "NAVEEN ENTR", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.METAL?.key },
	{ key: "AMMAN TAPE", name: "AMMAN TAPE", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.TAPE?.key },
	{
		key: "MANOHAR FILAMENTS (P) LTD",
		name: "MANOHAR FILAMENTS (P) LTD",
		[trimCategoryColumn?.key]: trimCategoryDropdownsObj?.TAPE?.key,
	},
	{ key: "DONGGUAN CINDA GARMENT", name: "DONGGUAN CINDA GARMENT", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.TAPE?.key },
	{ key: "CHAUDHARY LABELS", name: "CHAUDHARY LABELS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STICKER?.key },
	{ key: "ACE TRIMS", name: "ACE TRIMS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STICKER?.key },
	{ key: "PRIYA INTL", name: "PRIYA INTL", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STICKER?.key },
	{ key: "PHOENIX", name: "PHOENIX", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STICKER?.key },
	{ key: "NAVEEN ENTR", name: "NAVEEN ENTR", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STICKER?.key },
	{ key: "RELIABLE", name: "RELIABLE", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STICKER?.key },
	{ key: "MOVEYAA & ARW", name: "MOVEYAA & ARW ", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STICKER?.key },
	{
		key: "SUDARSHAN PACKWELL PVT. LTD",
		name: "SUDARSHAN PACKWELL PVT. LTD",
		[trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STRING?.key,
	},
	{ key: "RAKESH MARKETING", name: "RAKESH MARKETING", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STRING?.key },
	{ key: "MOVEYAA", name: "MOVEYAA", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STRING?.key },
	{ key: "ACE TRIMS", name: "ACE TRIMS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STRING?.key },
	{ key: "AMMAN TAPE", name: "AMMAN TAPE", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.CORD?.key },
	{ key: "MANGAL LACES", name: "MANGAL LACES", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "MOVEYYA", name: "MOVEYYA", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
];

export const trimCurrencyDropdowns = [
	{ key: "INR", name: "INR" },
	{ key: "USD", name: "USD" },
];

export const trimActiveStatusDropdowns = {
	ACTIVE: { key: "ACTIVE", name: "ACTIVE" },
	INACTIVE: { key: "INACTIVE", name: "INACTIVE" },
};

export const trimUnitDropdowns = [
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LABEL?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BUTTON?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BADGE?.key },
	{ key: "GRS", name: "GRS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.BUTTON?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.ELASTIC?.key },
	{ key: "MTR", name: "MTR", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.ELASTIC?.key },
	{ key: "YARD", name: "YARD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.ELASTIC?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "MTR", name: "MTR", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "YARD", name: "YARD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.HANGTAG?.key },
	{ key: "MTR", name: "MTR", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.HANGTAG?.key },
	{ key: "YARD", name: "YARD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.HANGTAG?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.METAL?.key },
	{ key: "GROSS", name: "GROSS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.METAL?.key },
	{ key: "YARD", name: "YARD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.TAPE?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.TAPE?.key },
	{ key: "GROSS", name: "GROSS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.TAPE?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STICKER?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.STRING?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.CORD?.key },
	{ key: "MTR", name: "MTR", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.CORD?.key },
	{ key: "YARD", name: "YARD", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.CORD?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.OTHER?.key },
	{ key: "PCS", name: "PCS", [trimCategoryColumn?.key]: trimCategoryDropdownsObj?.LACE?.key },
];

export const trimsMasterColumnsObj = {
	trim_code: {
		name: "Trim Code",
		key: "trim_code",
		input_type: inputTypes.AUTO_GENERATE.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	brand: {
		name: "Brand",
		key: "brand",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: Object.values(allBrands),
		},
	},
	garment_category: {
		name: "Garment Category",
		key: "garment_category",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
	},
	item_sub_category: {
		name: "Item Sub Category",
		key: "item_sub_category",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: trimSubCategoryDropdowns,
		},
	},
	item_description: {
		name: "Item Description",
		key: "item_description",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},

	size: {
		name: "Size",
		key: "size",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	color: {
		name: "Color",
		key: "color",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	final_finished_requirement: {
		name: "Final Finished Requirement",
		key: "final_finished_requirement",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: trimFinalFinishedReqDropdowns,
		},
	},
	shade: {
		name: "Shade",
		key: "shade",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	designer: {
		name: "Designer",
		key: "designer",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	date: {
		name: "Date",
		key: "date",
		data_type: datatypes.DATE.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
		default_value: moment().format("YYYY-MM-DD"),
	},
	development_file: {
		name: "Development File",
		key: "development_file",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	status: {
		name: "Status",
		key: "status",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
		default_value: statusOptions?.CREATED?.key,
	},
	published_by: {
		name: "Published By",
		key: "published_by",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	published_date: {
		name: "Published Date",
		key: "published_date",
		data_type: datatypes.DATE.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	trim_active_status: {
		name: "Active Status",
		key: "trim_active_status",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: Object.values(trimActiveStatusDropdowns),
		},
		constraints: { NOTNULL: false, DISPLAY: true },
		default_value: trimActiveStatusDropdowns?.INACTIVE?.key,
	},
	url: {
		name: "URL",
		key: "url",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	development_file: {
		name: "Development File",
		key: "development_file",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const trimDesignerDropdowns = [
	{ key: "PRANAB", name: "PRANAB", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "ASRA", name: "ASRA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "SWATI", name: "SWATI", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "ARUN", name: "ARUN", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "SHAILJA", name: "SHAILJA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "UJJAWAL", name: "UJJAWAL", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "SAMVEL", name: "SAMVEL", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "TARISHMA", name: "TARISHMA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "SOUMYA", name: "SOUMYA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "ANSHIKA", name: "ANSHIKA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE RABBIT"]?.key },
	{ key: "RONIKA", name: "RONIKA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RAREISM"]?.key },
	{ key: "BHARGAVI", name: "BHARGAVI", [trimsMasterColumnsObj?.brand?.key]: allBrands["RAREISM"]?.key },
	{ key: "NUPUR", name: "NUPUR", [trimsMasterColumnsObj?.brand?.key]: allBrands["RAREISM"]?.key },
	{ key: "UJJAWALA SINGH", name: "UJJAWALA SINGH", [trimsMasterColumnsObj?.brand?.key]: allBrands["RAREISM"]?.key },
	{ key: "AFREEN", name: "AFREEN", [trimsMasterColumnsObj?.brand?.key]: allBrands["RAREISM"]?.key },
	{ key: "HEMA", name: "HEMA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RAREISM"]?.key },
	{ key: "KULDEEP", name: "KULDEEP", [trimsMasterColumnsObj?.brand?.key]: allBrands["RAREISM"]?.key },
	{ key: "MEGHA", name: "MEGHA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE ONES"]?.key },
	{ key: "MAANASA", name: "MAANASA", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE ONES"]?.key },
	{ key: "NOAH", name: "NOAH", [trimsMasterColumnsObj?.brand?.key]: allBrands["RARE ONES"]?.key },
];

export const zipperExtraColumnsObj = {
	zipper_type: {
		name: "Zipper Type",
		key: "zipper_type",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: [
				{ name: "REVERSIBLE COIL", key: "REVERSIBLE COIL" },
				{ name: "COIL", key: "COIL" },
			],
		},
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	zipper_open_close: {
		name: "Zipper Open/Close",
		key: "zipper_open_close",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: [
				{ name: "OPEN END", key: "OPEN END" },
				{ name: "CLOSE END", key: "CLOSE END" },
			],
		},
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	zipper_puller_code: {
		name: "Zipper Puller Code",
		key: "zipper_puller_code",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: zipperPullerCodeDropdowns,
		},
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	zipper_puller_size: {
		name: "Zipper Puller Size",
		key: "zipper_puller_size",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	zipper_puller_finish: {
		name: "Zipper Puller Finish",
		key: "zipper_puller_finish",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
		constraints: { NOTNULL: true, DISPLAY: true },
	},
};

export const interliningExtraColumnsObj = {
	interlining_article_no: {
		name: "Interlining Article No",
		key: "interlining_article_no",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_composition: {
		name: "Interlining Composition",
		key: "interlining_composition",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_finish: {
		name: "Interlining Finish",
		key: "interlining_finish",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_construction_approx: {
		name: "Interlining Construction Approx",
		key: "interlining_construction_approx",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},

	interlining_weave: {
		name: "Interlining Weave",
		key: "interlining_weave",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_gsm: {
		name: "Interlining GSM",
		key: "interlining_gsm",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_width: {
		name: "Interlining Width",
		key: "interlining_width",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_coating_type: {
		name: "Interlining Coating Type",
		key: "interlining_coating_type",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_temprature: {
		name: "Interlining Temperature",
		key: "interlining_temprature",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_pressure: {
		name: "Interlining Pressure",
		key: "interlining_pressure",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	interlining_time: {
		name: "Interlining Time",
		key: "interlining_time",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
};

export const trimSampleApprovalDropdownObj = {
	PENDING: { key: "PENDING", name: "PENDING" },
	APPROVED: { key: "APPROVED", name: "APPROVED" },
	REJECTED: { key: "REJECTED", name: "REJECTED" },
};

export const trimDesignerApprovalDropdownObj = trimSampleApprovalDropdownObj;

const getLatestSampleRow = (samples = []) => {
	if (!samples.length) return null;

	const sorted = [...samples].sort((left, right) => {
		const leftCreated = new Date(left.created_at || left.createdAt || 0).getTime();
		const rightCreated = new Date(right.created_at || right.createdAt || 0).getTime();
		if (rightCreated !== leftCreated) return rightCreated - leftCreated;
		return (Number(right.id) || 0) - (Number(left.id) || 0);
	});

	const latest = sorted[0];
	if (latest?.created_at || latest?.createdAt || latest?.id) return latest;
	return samples[samples.length - 1];
};

export const deriveSupplierDesignerApprovalFromSamples = (samples = []) => {
	const pendingApproval = {
		designer_approval: trimDesignerApprovalDropdownObj.PENDING.key,
		approved_by: "",
		date_of_approval: null,
	};

	const latestSample = getLatestSampleRow(samples);
	if (!latestSample) return pendingApproval;

	const approval = latestSample?.approval || trimDesignerApprovalDropdownObj.PENDING.key;
	if (approval === trimDesignerApprovalDropdownObj.APPROVED.key || approval === trimDesignerApprovalDropdownObj.REJECTED.key) {
		return {
			designer_approval: approval,
			approved_by: latestSample?.approved_by || "",
			date_of_approval: latestSample?.date_of_approval || null,
		};
	}

	return pendingApproval;
};

export const trimsSupplierColumnsObj = {
	trim_supplier_code: {
		name: "Supplier Code",
		key: "trim_supplier_code",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	supplier: {
		name: "Supplier",
		key: "supplier",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	unit: {
		name: "Unit",
		key: "unit",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	currency: {
		name: "Currency",
		key: "currency",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	unit_price: {
		name: "Unit Price",
		key: "unit_price",
		data_type: datatypes.DECIMAL.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},

	supplier_reference_code: {
		name: "Supplier Reference Code",
		key: "supplier_reference_code",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
		default_value: NAOption.key,
	},
	designer_approval: {
		name: "Designer Approval",
		key: "designer_approval",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true },
		default_value: trimDesignerApprovalDropdownObj?.PENDING?.key,
	},
	approved_by: {
		name: "Approved By",
		key: "approved_by",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	date_of_approval: {
		name: "Date of Approval",
		key: "date_of_approval",
		data_type: datatypes.DATE.key,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	remarks: {
		name: "Remarks",
		key: "remarks",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	supplier_active_status: {
		name: "Active Status",
		key: "supplier_active_status",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: Object.values(trimActiveStatusDropdowns),
		},
		constraints: { NOTNULL: false, DISPLAY: true },
		default_value: trimActiveStatusDropdowns?.INACTIVE?.key,
	},
};

export const trimsPriceColumnsObj = trimsSupplierColumnsObj;

export const trimsSampleColumnsObj = {
	sample_etd_date: {
		name: "Sample ETD Date",
		key: "sample_etd_date",
		data_type: datatypes.DATE.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	sample_delivery_status: {
		name: "Sample Delivery Status",
		key: "sample_delivery_status",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: Object.values(trimDeliveryStatusDropdownObj),
		},
		constraints: { NOTNULL: true, DISPLAY: true },
		default_value: trimDeliveryStatusDropdownObj?.PENDING?.key,
	},
	sample_delivery_date: {
		name: "Sample Delivery Date",
		key: "sample_delivery_date",
		data_type: datatypes.DATE.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	approval: {
		name: "Approval",
		key: "approval",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: Object.values(trimSampleApprovalDropdownObj),
		},
		constraints: { NOTNULL: true, DISPLAY: true },
		default_value: trimSampleApprovalDropdownObj?.PENDING?.key,
	},
	approved_by: {
		name: "Approved By",
		key: "approved_by",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.SELECT.key,
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	date_of_approval: {
		name: "Date of Approval",
		key: "date_of_approval",
		data_type: datatypes.DATE.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	remarks: {
		name: "Remarks",
		key: "remarks",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const constructTrimFinalDataFunctionsObj = {
	[trimCategoryDropdownsObj?.LABEL?.key]: (row) => {
		let finalRow = { ...row };
		let itemDescription = "";
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key]} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.INTERLINING?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[interliningExtraColumnsObj?.interlining_article_no?.key] || ""} ${row[interliningExtraColumnsObj?.interlining_composition.key]} ${row[interliningExtraColumnsObj?.interlining_width?.key] || ""} ${row[interliningExtraColumnsObj?.interlining_coating_type?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""}  ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.ZIPPER?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[zipperExtraColumnsObj?.zipper_type.key] || ""} ${row[zipperExtraColumnsObj?.zipper_open_close?.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[zipperExtraColumnsObj?.zipper_puller_code?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.BUTTON?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.garment_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.BADGE?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.ELASTIC?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.LACE?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.HANGTAG?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.METAL?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.TAPE?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.STICKER?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.STRING?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""} ${row[trimsMasterColumnsObj?.final_finished_requirement?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.CORD?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""}`.trim();
		return finalRow;
	},
	[trimCategoryDropdownsObj?.OTHER?.key]: (row) => {
		let finalRow = { ...row };
		finalRow[trimsMasterColumnsObj?.item_description?.key] =
			`${row[trimsMasterColumnsObj?.brand?.key] || ""} ${row[trimsMasterColumnsObj?.item_sub_category.key] || ""} ${row[trimsMasterColumnsObj?.trim_code?.key] || ""} ${row[trimsMasterColumnsObj?.size?.key] || ""} ${row[trimsMasterColumnsObj?.color?.key] || ""}`.trim();
		return finalRow;
	},
};

export const getTrimMasterPayloadWithItemDescription = (row = {}) => {
	const category = row?.[trimCategoryColumn.key];
	const constructFn = constructTrimFinalDataFunctionsObj?.[category];

	if (typeof constructFn !== "function") {
		return {
			...row,
			[trimsMasterColumnsObj.item_description.key]: "",
		};
	}

	return constructFn(row);
};

export const lsTrimsFilterValStr = "trims_master_filter_obj";

const trimsDesignerFilterColumn = {
	...trimsMasterColumnsObj.designer,
	[selectOptionsKeyName]: {
		type: arrType,
		list: trimDesignerDropdowns,
	},
};

const trimsPublishStatusFilterColumn = {
	name: "Publish Status",
	key: "status",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	[selectOptionsKeyName]: {
		type: arrType,
		list: Object.keys(trimPublishStatusDisplay).map((key) => ({
			key,
			name: trimPublishStatusDisplay[key].label,
		})),
	},
};

const trimsSupplierNameFilterColumn = {
	...trimsSupplierColumnsObj.supplier,
	[selectOptionsKeyName]: {
		type: arrType,
		list: trimSupplierDropdowns,
	},
};

const trimsCurrencyFilterColumn = {
	...trimsSupplierColumnsObj.currency,
	[selectOptionsKeyName]: {
		type: arrType,
		list: trimCurrencyDropdowns,
	},
};

const trimsUnitFilterColumn = {
	...trimsSupplierColumnsObj.unit,
	[selectOptionsKeyName]: {
		type: arrType,
		list: trimUnitDropdowns,
	},
};

const trimsDesignerApprovalFilterColumn = {
	...trimsSupplierColumnsObj.designer_approval,
	input_type: inputTypes.SELECT.key,
	[selectOptionsKeyName]: {
		type: arrType,
		list: Object.values(trimDesignerApprovalDropdownObj),
	},
};

export const getTrimsMasterFilterColumns = () => [
	trimsMasterColumnsObj.trim_code,
	trimCategoryColumn,
	trimsMasterColumnsObj.item_sub_category,
	trimsMasterColumnsObj.item_description,
	trimsMasterColumnsObj.brand,
	trimsDesignerFilterColumn,
	trimsMasterColumnsObj.trim_active_status,
	trimsPublishStatusFilterColumn,
	publishColumns.published_by,
	...createdByColumns,
];

export const getTrimsSupplierFilterColumns = () => [
	trimsMasterColumnsObj.trim_code,
	trimsSupplierColumnsObj.trim_supplier_code,
	trimsSupplierNameFilterColumn,
	trimsSupplierColumnsObj.unit_price,
	trimsCurrencyFilterColumn,
	trimsUnitFilterColumn,
	trimCategoryColumn,
	trimsMasterColumnsObj.item_description,
	trimsMasterColumnsObj.brand,
	trimsDesignerFilterColumn,
	trimsSampleColumnsObj.sample_delivery_status,
	trimsDesignerApprovalFilterColumn,
	trimsSupplierColumnsObj.supplier_active_status,
	...createdByColumns,
];

export const getAllTrimsFilterColumnDefs = () => {
	const map = new Map();
	[...getTrimsMasterFilterColumns(), ...getTrimsSupplierFilterColumns()].forEach((col) => {
		if (col?.key) map.set(col.key, col);
	});
	return [...map.values()];
};
